/**
 * React subscription to the cached subscription config.
 * Re-renders the consuming component when the config fetch resolves, so
 * tier/limit logic computed during an early render doesn't stay stale.
 */
import { useSyncExternalStore } from 'react';
import {
  subscribeSubscriptionConfig,
  getCachedSubscriptionConfig,
  loadSubscriptionConfig,
} from '../utils/subscriptionConfig';

export const useSubscriptionConfig = () => {
  loadSubscriptionConfig(); // idempotent — ensures the fetch is in flight
  return useSyncExternalStore(subscribeSubscriptionConfig, getCachedSubscriptionConfig);
};
